<mat-icon
    svgIcon="kebab-menu"
    class="hyperlink-menu-icon"
    data-uiid="kebab-menu-trigger"
    aria-hidden="true"
    [matMenuTriggerFor]="hyperlinkMenu"
></mat-icon>

<mat-menu #hyperlinkMenu="matMenu" class="kebab-popup-menu">
    @for (menuItem of menuItems; track menuItem.text) {
        <button
            mat-menu-item
            [attr.data-uiid]="'kebab-menu-item-' + menuItem.icon"
            (click)="menuItem.onClick()"
        >
            <mat-icon
                class="hyperlink-menu-icon"
                [svgIcon]="menuItem.icon"
            ></mat-icon>
            <span class="hyperlink-menu-text">{{ menuItem.text }}</span>
        </button>
    }
</mat-menu>
